<script>
    import MetricItem from "./metric_item.svelte";
    import { t } from "$lib/i18n.js";
</script>
<div>
    <MetricItem headline={$t('routes.owner.metrics.cols.1.headline')} subheadline={$t('routes.owner.metrics.cols.1.subheadline')} icon='🚙'/>
    <MetricItem headline={$t('routes.owner.metrics.cols.2.headline')} subheadline={$t('routes.owner.metrics.cols.2.subheadline')} icon='🙋'/>
    <MetricItem headline={$t('routes.owner.metrics.cols.3.headline')} subheadline={$t('routes.owner.metrics.cols.3.subheadline')} icon='💙'/>
    <MetricItem headline={$t('routes.owner.metrics.cols.4.headline')} subheadline={$t('routes.owner.metrics.cols.4.subheadline')} icon='🛟'/>
</div>

<style>
    div {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 40px;
        padding-top: 40px;
        padding-bottom: 120px;
        max-width: 1000px;
        margin: auto;
    }

    @media (max-width: 768px) {
        /* 2x2 grid on mobile */
        div {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            padding-top: 60px;
            padding-bottom: 60px;
            padding-left: 16px;
            padding-right: 16px;
            gap: 4px;
        }
    }
</style>